import * as React from "react";
import { Stack, useRouter } from "expo-router";

import { AccountForm } from "~/components/AccountForm";
import { colors } from "~/colors";
import { useCreateAccount } from "~/hooks/useCreateAccount";
import { supabaseClient, useSessionContext } from "~/lib/supabase";
import { useGlobalStore } from "~/stores/global";

export default function CreateAccountPage() {
  const storeContext = useGlobalStore();
  const { createAccount } = useCreateAccount();
  const { replace } = useRouter();
  const { session } = useSessionContext();

  React.useEffect(() => {
    if (storeContext.loading) return;
    if (!storeContext.store?.personalAccount) return;

    replace(`/create-account/profile`);
  }, [storeContext.loading, storeContext.store?.personalAccount, replace]);

  const onSubmit = async (data: {
    password: string;
    displayName: string;
    slug: string;
  }) => {
    await supabaseClient.auth.updateUser({
      password: data.password,
    });
    return createAccount({
      displayName: data.displayName,
      type: "USER",
      slug: data.slug,
    });
  };

  return (
    <>
      <Stack.Screen
        options={{
          headerTitle: "Setup your profile",
          headerTitleStyle: {
            color: colors.text.primary,
          },

          headerBackTitleVisible: false,
        }}
      />
      <AccountForm email={session?.user.email!} onSubmit={onSubmit} />
    </>
  );
}
